import React, { useState, useEffect, useCallback } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import {
  FaHome, FaBuilding, FaEnvelope, FaSignOutAlt,
  FaBars, FaTimes, FaExternalLinkAlt, FaBell
} from 'react-icons/fa';
import { useAuth } from '../../context/AuthContext';
import { adminApi } from '../../services/api';
import './Admin.css';

const AdminLayout = ({ children, title }) => {
  const { username, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);

  const fetchUnread = useCallback(async () => {
    try {
      const res = await adminApi.getAllMessages();
      const unread = (res.data?.data || []).filter(m => !m.read).length;
      setUnreadCount(unread);
    } catch (_) {}
  }, []);

  useEffect(() => {
    fetchUnread();
    const interval = setInterval(fetchUnread, 60000);
    return () => clearInterval(interval);
  }, [fetchUnread]);

  const handleLogout = async () => {
    await logout();
    navigate('/admin12');
  };

  const navLinks = [
    { to: '/admin12/dashboard', icon: <FaHome />, label: 'Dashboard' },
    { to: '/admin12/propiedades', icon: <FaBuilding />, label: 'Propiedades' },
    {
      to: '/admin12/mensajes',
      icon: <FaEnvelope />,
      label: 'Mensajes',
      badge: unreadCount > 0 ? unreadCount : null,
    },
  ];

  const isActive = (path) => location.pathname === path || location.pathname.startsWith(path + '/');

  return (
    <div className="admin-layout">
      {/* Sidebar */}
      <aside className={`admin-sidebar ${sidebarOpen ? 'admin-sidebar--open' : ''}`}>
        <div className="admin-sidebar__header">
          <FaHome className="admin-sidebar__logo-icon" />
          <div>
            <div className="admin-sidebar__name">Casa Bonita</div>
            <div className="admin-sidebar__user">Hola, {username}</div>
          </div>
          <button
            className="admin-sidebar__close"
            onClick={() => setSidebarOpen(false)}
          >
            <FaTimes />
          </button>
        </div>

        <nav className="admin-sidebar__nav">
          {navLinks.map(link => (
            <Link
              key={link.to}
              to={link.to}
              className={`admin-nav-link ${isActive(link.to) ? 'admin-nav-link--active' : ''}`}
              onClick={() => setSidebarOpen(false)}
            >
              <span className="admin-nav-link__icon">{link.icon}</span>
              <span>{link.label}</span>
              {link.badge && (
                <span className="admin-nav-link__badge">{link.badge}</span>
              )}
            </Link>
          ))}
        </nav>

        <div className="admin-sidebar__footer">
          <a
            href="/"
            target="_blank"
            rel="noopener noreferrer"
            className="admin-sidebar-action"
          >
            <FaExternalLinkAlt /> Ver sitio público
          </a>
          <button className="admin-sidebar-action admin-sidebar-action--danger" onClick={handleLogout}>
            <FaSignOutAlt /> Cerrar sesión
          </button>
        </div>
      </aside>

      {/* Overlay mobile */}
      {sidebarOpen && (
        <div className="admin-overlay" onClick={() => setSidebarOpen(false)} />
      )}

      {/* Content */}
      <div className="admin-content">
        <header className="admin-topbar">
          <button className="admin-topbar__menu" onClick={() => setSidebarOpen(true)}>
            <FaBars />
          </button>
          <h1 className="admin-topbar__title">{title}</h1>
          <div className="admin-topbar__right">
            {unreadCount > 0 && (
              <Link to="/admin12/mensajes" className="admin-bell">
                <FaBell />
                <span>{unreadCount}</span>
              </Link>
            )}
          </div>
        </header>

        <main className="admin-main">
          {children}
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
